// apps/client/src/net/handlers/decor.ts (M1-T16) — live changes for everyone in the room (spec §9.9): placed, moved and stored
// furniture, and new wallpaper or floor. Outdoor items (yards included) are M1-T13's items handler.
import type { NetHandlers } from '../../game/game';
import { isRoomScene } from '../../world/spaces/room';

export const handlers: NetHandlers = {
  events: {
    'item.added': (e, game) => { const s = game.scenes.current; if (isRoomScene(s) && e.item.at.loc === 'room' && e.item.at.space === game.you()?.space) void s.addItem(e.item); },
    'item.updated': (e, game) => { const s = game.scenes.current; if (isRoomScene(s) && e.item.at.loc === 'room' && e.item.at.space === game.you()?.space) s.updateItem(e.item); },
    'item.removed': (e, game) => { const s = game.scenes.current; if (isRoomScene(s)) s.removeItem(e.item); },
    'room.updated': (e, game) => {
      const s = game.scenes.current;
      if (isRoomScene(s) && game.you()?.space === `house:${e.room.owner}:${e.room.index}`) s.setRoom(e.room);
    },
  },
};
